import React from "react";
import { COHORT_OPTIONS, WEBINAR_API } from "../../../constants";
import { SessionFormState } from "../../../utils/sessionFormState";

type Props = {
  form: SessionFormState;
  setField: <K extends keyof SessionFormState>(
    key: K,
    value: SessionFormState[K],
  ) => void;
};

const AudienceStep: React.FC<Props> = ({ form, setField }) => {
  const toggleCohort = (cohort: string) => {
    const has = form.cohorts.includes(cohort);
    setField(
      "cohorts",
      has
        ? form.cohorts.filter((c) => c !== cohort)
        : [...form.cohorts, cohort],
    );
  };

  const open = form.access === "open";
  const members = form.access === "members";
  const showCohorts = members && WEBINAR_API.canUseCohorts;

  return (
    <div className="wf-step">
      <div>
        <label className="wf-field__label" style={{ marginBottom: 9 }}>
          Access <span className="req">*</span>
        </label>
        <div className="wf-access">
          <button
            type="button"
            className={`wf-access__card${open ? " is-active" : ""}`}
            onClick={() => setField("access", "open")}
          >
            <div className="wf-access__row">
              <span className={`wf-access__dot${open ? " is-on" : ""}`} />
              <span className="wf-access__title">Open to everyone</span>
            </div>
            <div className="wf-access__desc">
              Visible and joinable for free and paying members alike.
            </div>
          </button>
          <button
            type="button"
            className={`wf-access__card${members ? " is-active" : ""}`}
            onClick={() => setField("access", "members")}
          >
            <div className="wf-access__row">
              <span className={`wf-access__dot${members ? " is-on" : ""}`} />
              <span className="wf-access__title">Paid Plan Users Only</span>
            </div>
            <div className="wf-access__desc">
              Only accessible by users who are on paid program. Non-program
              members won't be able to join the meeting.
            </div>
          </button>
        </div>
        {/* {members && !WEBINAR_API.canUseCohorts ? (
          <div className="wf-field__hint" style={{ marginTop: 8 }}>
            Paid members only. Cohort targeting will unlock when the API is
            ready.
          </div>
        ) : null} */}
      </div>

      {showCohorts ? (
        <div className="wf-cohorts-box">
          <div className="wf-cohorts-box__head">
            <div>
              Cohorts <span className="req">*</span>
            </div>
          </div>
          <div className="wf-cohorts">
            {COHORT_OPTIONS.map((c) => {
              const active = form.cohorts.includes(c.label);
              return (
                <button
                  key={c.label}
                  type="button"
                  className={`wf-cohort-chip${active ? " is-active" : ""}`}
                  onClick={() => toggleCohort(c.label)}
                >
                  <span
                    className={`wf-cohort-chip__box${active ? " is-on" : ""}`}
                  >
                    {active ? (
                      <svg
                        width="9"
                        height="9"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="3.6"
                        strokeLinecap="round"
                      >
                        <path d="M20 6L9 17l-5-5" />
                      </svg>
                    ) : null}
                  </span>
                  {c.label}
                  <span className="wf-cohort-chip__size">{c.size}</span>
                </button>
              );
            })}
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default AudienceStep;
